"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var newestToOldest = function newestToOldest(a, b) {
  if (a.lastUpdated === b.lastUpdated) return 0;
  return a.lastUpdated > b.lastUpdated ? -1 : 1;
};

var getLastUpdatedManualScore = function getLastUpdatedManualScore() {
  var manualScores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _lodash["default"].first(manualScores.sort(newestToOldest));
};

var _default = {
  getLastUpdatedManualScore: getLastUpdatedManualScore
};
exports["default"] = _default;